import HttpClient from "@/common/boot/HttpClient"

const listarFormularios = async ({ commit }, payload) => {
  commit('CARREGANDO', true);
  await HttpClient.get('/ctrl-formularios', { params: payload }).then(response => {
    commit('LISTAR_DADOS', response.data.data);
    return response;
  });
  commit('CARREGANDO', false);
}

const salvarFormulario = async ({ commit, dispatch }, payload) => {
    console.log('Salvando formulario', payload);
  commit('CARREGANDO', true);
  return await HttpClient.post('/ctrl-formularios', payload).then(response => {
    dispatch('listarFormularios');
    return response;
  })
  .finally(() => {
    commit('CARREGANDO', false);
  });
}

const atualizarFormulario = async ({ commit, dispatch }, payload) => {
  commit('CARREGANDO', true);
  return await HttpClient.put(`/ctrl-formularios/${payload.id}`, payload).then(response => {
    dispatch('listarFormularios');
    return response;
  })
  .finally(() => {
    commit('CARREGANDO', false);
  });
}

const excluirFormularios = async ({ commit, dispatch }, payload) => {
  commit('CARREGANDO', true);
  for(const item of payload) {
    await HttpClient.delete(`/ctrl-formularios/${item.id}`);
  }
  await dispatch('listarFormularios');
  commit('CARREGANDO', false);
}

const restaurarFormulario = async ({ commit, dispatch }, payload) => {
  commit('CARREGANDO', true);
  return await HttpClient.post(`/ctrl-formularios/${payload}/restaurar`).then(response => {
    dispatch('listarFormularios');
    return response;
  }).finally(() => {
    commit('CARREGANDO', false);
  });
}

export {
  listarFormularios,
  salvarFormulario,
  atualizarFormulario, 
  excluirFormularios,
  restaurarFormulario
}